import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { VoidFunc } from 'types/types';
import './Popup.pcss';
import { observer } from 'mobx-react';
import { Button } from 'components/widgets/Button';



export function openConfirmPopup(message:string, onConfirm:()=>void, title?:string, onCancel?:()=>void,  onOverlayClicked?:VoidFunc, preventCloseOnOverlayClick?:boolean) {
  const content = (
    <div className="confirm">
      <h1>{title?title:'Are you sure?'}</h1>
      <p>{message}</p>
      <div className="btns">
        <Button flat onClick={onConfirm}>OK</Button>
        <Button flat cancel onClick={onCancel?onCancel:closePopup}>CANCEL</Button>
      </div>
    </div>
  )
  ReactDOM.render(
    <Popup onOverlayClicked={onOverlayClicked} preventCloseOnOverlayClick={preventCloseOnOverlayClick}>{content}</Popup>, 
    document.getElementById('popup')
  );
}

// export function openAlertPopop(message:string, title?:string, buttonLabel?:string, onOverlayClicked?:VoidFunc, preventCloseOnOverlayClick?:boolean) {
//   const content = (
//     <div className="alert">
//       <h1>{title?title:'Alert'}</h1>
//       <p>{message}</p>
//       <div className="btns">
//         <Button flat onClick={closePopup}>{buttonLabel?buttonLabel:'OK'}</Button>
//       </div>
//     </div>
//   )
//   ReactDOM.render(
//     <Popup onOverlayClicked={onOverlayClicked} preventCloseOnOverlayClick={preventCloseOnOverlayClick}>{content}</Popup>,
//     document.getElementById('popup')
//   );
// }

export function openPopop(content:any, onOverlayClicked?:VoidFunc, preventCloseOnOverlayClick?:boolean) {
  ReactDOM.render(
    <Popup onOverlayClicked={onOverlayClicked} preventCloseOnOverlayClick={preventCloseOnOverlayClick}>{content}</Popup>, 
    document.getElementById('popup')
  );
}

export function closePopup() {
  const popupElement = document.getElementById('popup');
  if(popupElement) {
    ReactDOM.unmountComponentAtNode(popupElement);
  }
}


@observer
export class Popup extends React.Component<{onOverlayClicked?:VoidFunc, preventCloseOnOverlayClick?:boolean}> {
  overlayClicked = () => {
    if(this.props.onOverlayClicked) {
      this.props.onOverlayClicked();
    }
    if(!this.props.preventCloseOnOverlayClick) {
      closePopup();
    }
  }
  render() {    
    return (
      <div className="pcontainer">
        <div className="poverlay" onClick={this.overlayClicked}></div>
        <div className="pcontent">{this.props.children}</div>
      </div>
    );
  }
}
